import { Routes } from '@angular/router';
import { LayoutComponent } from './layout/layout/layout.component';
import { authGuard, publicGuard, roleGuard } from './core/guards/auth.guard';

export const routes: Routes = [
    // Redireccionamiento raíz
    { path: '', redirectTo: 'dashboard', pathMatch: 'full' },

    // Autenticación (pública)
    {
        path: 'auth',
        canActivate: [publicGuard],
        children: [
            {
                path: 'login',
                loadComponent: () => import('./auth/auth.component').then((m) => m.AuthComponent)
            },
            { path: '', redirectTo: 'login', pathMatch: 'full' }
        ]
    },

    // App principal (protegida)
    {
        path: '',
        component: LayoutComponent,
        canActivate: [authGuard],
        children: [
            {
                path: 'dashboard',
                canActivate: [roleGuard],
                data: { roles: ['ADMIN', 'SUPERVISOR', 'TECNICO'] },
                loadComponent: () => import('./modules/dashboard/dashboard.component').then((m) => m.DashboardComponent)
            },
            {
                path: 'tickets',
                canActivate: [roleGuard],
                data: { roles: ['ADMIN', 'SUPERVISOR', 'TECNICO', 'SOLICITANTE', 'CONTABILIDAD', 'RRHH'] },
                loadComponent: () => import('./modules/tickets/tickets.component').then((m) => m.TicketsComponent)
            },
            {
                path: 'entities',
                canActivate: [roleGuard],
                data: { roles: ['ADMIN', 'SUPERVISOR', 'RRHH'] },
                loadComponent: () => import('./modules/entities/entities.component').then((m) => m.EntitiesComponent)
            },
            {
                path: 'branches',
                canActivate: [roleGuard],
                data: { roles: ['ADMIN', 'SUPERVISOR', 'RRHH'] },
                loadComponent: () => import('./modules/branches/branches.component').then((m) => m.BranchesComponent)
            },
            {
                path: 'divisions',
                canActivate: [roleGuard],
                data: { roles: ['ADMIN', 'SUPERVISOR', 'RRHH'] },
                loadComponent: () => import('./modules/divisions/divisions.component').then((m) => m.DivisionsComponent)
            },
            {
                path: 'billing-categories',
                canActivate: [roleGuard],
                data: { roles: ['ADMIN', 'CONTABILIDAD', 'RRHH'] },
                loadComponent: () => import('./modules/billing-categories/billing-categories.component').then((m) => m.BillingCategoriesComponent)
            },
            {
                path: 'areas',
                canActivate: [roleGuard],
                data: { roles: ['ADMIN', 'SUPERVISOR'] },
                loadComponent: () => import('./modules/areas/areas.component').then((m) => m.AreasComponent)
            },
            {
                path: 'equipment',
                canActivate: [roleGuard],
                data: { roles: ['ADMIN', 'SUPERVISOR', 'TECNICO'] },
                loadComponent: () => import('./modules/equipment/equipment.component').then((m) => m.EquipmentComponent)
            },
            {
                path: 'users',
                canActivate: [roleGuard],
                data: { roles: ['ADMIN', 'RRHH'] },
                loadComponent: () => import('./modules/users/users.component').then((m) => m.UsersComponent)
            },
{
                path: 'maintenance',
                canActivate: [roleGuard],
                data: { roles: ['ADMIN', 'SUPERVISOR', 'TECNICO', 'CONTABILIDAD', 'RRHH'] },
                loadComponent: () => import('./modules/maintenance-tickets/maintenance-tickets.component').then((m) => m.MaintenanceTicketsComponent)
            },
            {
                path: 'presupuestos',
                canActivate: [roleGuard],
                data: { roles: ['ADMIN', 'SUPERVISOR', 'TECNICO', 'CONTABILIDAD'] },
                loadComponent: () => import('./modules/presupuestos/presupuestos.component').then((m) => m.PresupuestosComponent)
            },
            {
                path: 'maintenance-processes',
                canActivate: [roleGuard],
                data: { roles: ['ADMIN', 'SUPERVISOR', 'TECNICO'] },
                loadComponent: () => import('./modules/maintenance-processes/maintenance-processes.component').then((m) => m.MaintenanceProcessesComponent)
            },
            {
                path: 'reports',
                canActivate: [roleGuard],
                data: { roles: ['ADMIN', 'RRHH', 'CONTABILIDAD'] },
                loadChildren: () => import('./modules/reports/reports.routes').then(m => m.reportsRoutes)
            },
            {
                path: 'activities',
                canActivate: [roleGuard],
                data: { roles: ['ADMIN', 'SUPERVISOR', 'TECNICO'] },
                loadComponent: () => import('./modules/activities/activities.component').then((m) => m.ActivitiesComponent)
            },
            {
                path: 'cash-registers',
                canActivate: [roleGuard],
                data: { roles: ['ADMIN', 'SUPERVISOR', 'TECNICO', 'RRHH', 'CONTABILIDAD'] },
                loadComponent: () => import('./modules/cash-registers/cash-registers.component').then((m) => m.CashRegistersComponent)
            },
            {
                path: 'tools',
                canActivate: [roleGuard],
                data: { roles: ['ADMIN', 'SUPERVISOR'] },
                loadComponent: () => import('./modules/tools/tools.component').then((m) => m.ToolsComponent)
            },
            {
                path: 'work-sessions',
                canActivate: [roleGuard],
                data: { roles: ['ADMIN', 'SUPERVISOR'] },
                loadComponent: () => import('./modules/work-sessions/work-sessions.component').then((m) => m.WorkSessionsComponent)
            }
        ]
    },

    // Fallback
    { path: '**', redirectTo: 'dashboard' }
];
